import App from '../components/App.vue'
import FollowButton from '../components/FollowButton.vue'
import FollowButtonGuest from "../components/FollowButtonGuest"
import SignIn from "../components/SignIn"
import SignUp from "../components/SignUp"

export default {
  components: {
    App,
    FollowButton,
    FollowButtonGuest,
    SignIn,
    SignUp
  },
  data: () => ({
  }),

}
